import { useEffect, useRef, useState } from 'preact/hooks';

export function useDebouncedState<T = any>(
  defaultValue: T,
  wait: number,
  options = { leading: false }
) {
  const [value, setValue] = useState(defaultValue);
  const timeoutRef = useRef<number>();
  const leadingRef = useRef<boolean>();

  const clearTimeout = () =>
    window.clearTimeout(timeoutRef.current || undefined);
  useEffect(() => clearTimeout, []);

  const debouncedSetValue = (newValue: T) => {
    clearTimeout();
    if (leadingRef.current && options.leading) {
      setValue(newValue);
    } else {
      timeoutRef.current = window.setTimeout(() => {
        leadingRef.current = true;
        setValue(newValue);
      }, wait);
    }
    leadingRef.current = false;
  };

  const setValueImmediate = (newValue: T) => {
    clearTimeout();
    leadingRef.current = true;
    setValue(newValue);
  };

  return [value, debouncedSetValue, setValueImmediate] as const;
}
